module.exports = __webpack_public_path__ + "img/evo_classroom.4579900b.png";